window.sswcustom = {
    bind: {
        wishlistIcon: async e => {
            const ele = e.currentTarget,
                status = ele.classList.contains("wishlist-added") ? "remove" : "add";
            ele.classList.add("wishlist-pending");
            const favelist_id = await window.sswcustom.createWishlist(e);
            window.sswcustom.addRemoveFave(status, favelist_id, ele.dataset.productId, ele.dataset.params.page, data => {
                if (data.success) {
                    if (status == "remove") {
                        ele.classList.remove("wishlist-added");
                    } else {
                        ele.classList.add("wishlist-added");
                    }
                    window.sswcustom.countFave(function (s) {
                        document.querySelector(".ssw-counter-fave-menu").innerHTML = s.count;
                    });
                }
                ele.classList.remove("wishlist-pending");
            });
        },
        all: e => {
            [...document.querySelectorAll('[data-wishlist-handle]')].forEach (wishlistIcon => {
                wishlistIcon.addEventListener('click', window.sswcustom.bind.wishlistIcon.bind(this))
            });
        }
    },
    addRemoveFave: function (status, favelist_id, productId, page, callback, first_variant_id = 0) {
        let o = JSON.parse(localStorage.getItem("gw_has_guest_wishlist_items")) ?? !0,
            url = status == "remove" ? "/lite2/unfave" : "/lite2/fave",
            d = {
                product_id: productId,
                _sid: window.sswCookie("hesid"),
                hash_key: window.sswCookie("hash_key"),
                has_guest_wishlist_items: o,
                page: page,
                event: "fave",
                first_variant_id: first_variant_id,
                favelist_id: favelist_id,
                variant_id: 0
            },
            a = $.post(window.sswProxyUrl + url, d, (function (s) {

                callback(s);
            }), "json")
    },
    countFave: function (callback) {
        const s = {
            _sid: $.cookie("hesid"),
            hash_key: $.cookie("hash_key")
        };

        $.post(window.sswProxyUrl + "/lite2/fave-count", s, "json").done((s => {
            callback(s);
        })).fail((s => {
            console.log("fave-count fail");
        }))
    },
    getFaves(ids, callback) {
        const t = JSON.parse(localStorage.getItem("gw_has_guest_wishlist_items")) ?? !0,
            a = {
                ids: ids.join("I"),
                _sid: $.cookie("hesid"),
                hash_key: $.cookie("hash_key"),
                has_guest_wishlist_items: t
            };
        $.post(window.sswProxyUrl + "/lite2/feed/getFaves", a, (t => {
            callback(t);
        }), "json")
    },
    findAllProductIds() {
        return [...document.querySelectorAll(".card-wishlist.wishlist-icon")]
            .map(wishlistIcon => wishlistIcon.dataset.productId);
    },
    updateAllWishlistIcons() {
        const ids = window.sswcustom.findAllProductIds();
        window.sswcustom.getFaves(ids, (data) => {
            let e, a = parseInt(data.fave_with_variant) || 0,
                i = data.fave_multiple_variant || 0;
            Object.keys(data.viewer_faves).forEach(key => {
                if (data.viewer_faves[key][0] > 0) {
                    if (ids.indexOf(key) >= 0) {
                        document.querySelector('.card-wishlist.wishlist-icon[data-product-id="' + key + '"]')
                            .classList.add("wishlist-added");
                    }
                }
            });
        });
    },
    createWishlist: async e => {
        const ele = e.currentTarget;
        let favelist_id;
        var save_later_exist = false;
        const t = JSON.parse(localStorage.getItem("gw_has_guest_wishlist_items")) ?? !0;
        const faveList = await $.get(window.sswProxyUrl + "/lite2/faves-lists?_sid=" + $.cookie("hesid") + "&hash_key=" + $.cookie("hash_key") + "&has_guest_wishlist_items=" + t);

        var data = JSON.parse(faveList);
        console.log("list==", data.lists);
        data.lists.forEach(function (item, index) {

            if (item[3] == "SAVE FOR LATER") {
                console.log("list====", item[3]);
                save_later_exist = true;
                favelist_id = item.favelist_id;
            }
        });

        if (save_later_exist == false) {
            console.log("list inside====");
            const s = {
                title: "SAVE FOR LATER",
                _sid: $.cookie("hesid"),
                hash_key: $.cookie("hash_key")
            };

            const saveforlaterList = await $.post(window.sswProxyUrl + "/lite2/fave-list-create", s, "json");
            favelist_id = saveforlaterList.favelist_id;
            console.log(saveforlaterList, 'this is s');

        }
        return favelist_id;
    },

    all: e => {
        [...document.querySelectorAll('.save-for-later')].forEach(wishlistIcon => {
            wishlistIcon.addEventListener('click', window.sswcustom.bind.wishlistIcon.bind(this))
        });
    }
}
window.sswcustom.all();
 function saveforlater (){
        const ids =  [...document.querySelectorAll(".save-for-later")]
            .map(wishlistIcon => wishlistIcon.dataset.productId);
        window.sswcustom.getFaves(ids, (data) => {
            let e, a = parseInt(data.fave_with_variant) || 0,
                i = data.fave_multiple_variant || 0;
            Object.keys(data.viewer_faves).forEach(key => {
                if (data.viewer_faves[key][0] > 0) {
                    if (ids.indexOf(key) >= 0) {
                        document.querySelector('.save-for-later[data-product-id="' + key + '"]')
                            .classList.add("wishlist-added");
                    }
                }
            });
        });
    }

window.addEventListener("SSW_WISHLIST_CRITICAL_LOADED", (e) => {
  console.log("SSW_WISHLIST_CRITICAL_LOADED");
    window.sswcustom.updateAllWishlistIcons();
    window.sswcustom.bind.all();
    saveforlater();
});
